import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TabTemplatePicker from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker';
import ActionBar
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/ActionBar';
import LinterDrawer from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/LinterDrawer';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.facet.lightGray,
  },
  actionbar: {
    flexShrink: 0,
  },
  tabContent: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2, 0),
  },
});

const Template = ({ className, classes }) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <ActionBar className={classes.actionbar} />
      <div className={classes.tabContent}>
        <TabTemplatePicker />
      </div>
      <LinterDrawer />
    </Box>
  );
};

Template.defaultProps = {
  className: '',
};

Template.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Template);
